
import React, {useState} from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import FormInput from 'ui-components/FormInput';
import { Button } from 'material-ui';
import { invalidPasswordMessage, invalidPhoneMessage, passwordRegex, phoneRegex, emailRegex, invalidEmailMessage, phoneInputLabel } from 'service/constants';
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import { faSpinner } from '@fortawesome/fontawesome-free-solid'
 
import './register-form.scss'
import { login } from '../../../actions';
import { updateCounsellorInfo, updateCounsellorPhone } from '../../../../../service/api';
import { showMessage } from '../../../../messages/actions';
import { failedMessage } from '../../../../../service/constants';
import { isEmpty } from 'utils/utils';

const RegisterForm = ({closeHandler, email}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const {
        register,
        formState: { errors },
        handleSubmit,
        watch
    } = useForm({
        mode: "onSubmit",
        reValidateMode: 'onChange',
        defaultValues: {
            username: email,
            phone: "+1"
        }
    });
    
    const onSubmit = async (data) => {
        const {username, password, phone} = data 

        try {
            setLoading(true)
            await dispatch(login({username, password}, true))
            await updateCounsellorPhone(phone)
            closeHandler()
        } catch(error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const {password, phone, username} = watch()
    const isBtnDisabled = !password || !phone || !username || loading || !isEmpty(errors)
    return (
        <form 
            className="register-form"
            onSubmit={handleSubmit(onSubmit)}
        >
           <FormInput
                title={"Email"}
                register={register}
                errors={errors}
                name={"username"}
                pattern={emailRegex}
                invalidMessage={invalidEmailMessage}
                defaultValue={email}

            />
           <FormInput
                title={"Password"}
                register={register}
                errors={errors}
                name={"password"}
                pattern={null}
                invalidMessage={invalidPasswordMessage}
                isPassword={true}
            />
            <FormInput
                title={"Phone"}
                register={register}
                errors={errors}
                name={"phone"}
                pattern={phoneRegex}
                invalidMessage={invalidPhoneMessage}
                isPhone={true}
                label={phoneInputLabel}
            />
            <Button
                color="secondary" 
                variant="raised" 
                className="submit-button"
                type="submit"
                disabled={isBtnDisabled}
            >
                { loading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Submit"}
            </Button>
        </form>
    );
};

export default RegisterForm;
